// @flow

import React from "react";

import { Checkbox as StyledCheckbox } from "src/styles/input.old";

type Props = {
  id: string,
  checked?: boolean,
  children?: any,
  handleChange?: Function,
  isDisabled?: ?boolean,
};

const Checkbox = ({
  id,
  checked = false,
  children = null,
  handleChange = () => {},
  isDisabled = false,
}: Props) => {
  return (
    <StyledCheckbox data-cy="checkbox-container" disabled={isDisabled}>
      <label htmlFor={id}>
        <input
          data-cy="checkbox"
          type="checkbox"
          onChange={handleChange}
          checked={checked}
          id={id}
          disabled={isDisabled}
        />
        <div />
        <span>{children}</span>
      </label>
    </StyledCheckbox>
  );
};

export default Checkbox;
